import { HttpClient, JSON_STRING } from "../../../services/http/http-client";

export const PluginsService = {
  findAll: () => {
    return HttpClient.get("/plugins.pl", {
      section: "plugins",
      action: "get_section_plugins",
      plugins_section: "Booking",
      output: "json"
    });
  },
  findArtistTravelContacts: (start = 0, date1 = '', date2 = '') => {
    return HttpClient.get("/booking.pl", {
      section: "plugins",
      action: "getTravelsContacts",
      start: start,
      date1: date1,
      date2: date2
    });
  },
  findArtist: () => {
    return HttpClient.get("/plugins.pl", {
      section: "plugins",
      action: "activate_custom_sql_api_and_get_api_checksum",
      custom_sql_id: 98
    });
  },

  // https://dev.berlin3.com/berlin3/plugins.pl
  // section: plugins
  // plugins_section: Booking
  // action: activate_selected_plugin
  // plugin_id: 933

  activatePlugin: ({
    plugins_section = 'Booking',
    plugin_id,
  }) => {
    return HttpClient.post("/plugins.pl", {
      section: 'plugins',
      action: 'activate_selected_plugin',
      plugins_section,
      plugin_id,
    })
  }

};
